export default function () {
  $('.people-list__read-more').click(function () {
    let container = $(this).closest('.people-list__item-info');
    container.toggleClass('is--expanded');

    let label = $(this).find('.people-list__label');

    if (container.hasClass('is--expanded')) {
      label.text('Read Less');
    } else {
      label.text('Read More');
    }
  });
}
